import apiService from '@/services/apiService';

const actions = {
  getMoreInfo({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.get(`paxel-recycle/more-info`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
  postMoreInfo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-recycle/more-info', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default actions;
